import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import qs from 'qs';

import * as actions from '../actions';
import * as commonActions from '../../common/actions';

import { BrandBand } from '../../common/components';
import { ActivateContent } from '../components';

import './Activate.scss';

export class Activate extends Component {
  componentDidMount() {
    const parsedQueryString = qs.parse(this.props.location.search.substr(1));
    this.props.actions.getNotificationEmail(parsedQueryString);
  }

  render() {
    const { frequency, actions, location, modals } = this.props;
    return (
      <BrandBand>
        <div className="container-activate">
          <ActivateContent
            activation={frequency.activation}
            dataFilter={frequency.dataExtension.dataFilter}
            frequencies={frequency.frequencies}
            notificationSubscribers={frequency.notificationSubscribers}
            modals={modals}
            actions={actions}
            location={location}
            history={this.props.history}
          />
        </div>
      </BrandBand>
    );
  }
}

Activate.propTypes = {
  children: PropTypes.element,
  actions: PropTypes.object,
  location: PropTypes.object,
  frequency: PropTypes.object,
  modals: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    frequency: state.frequency,
    modals: state.modals,
    welcomeMat: state.welcomeMat
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Activate);
